import { FILE_ITEM_WIDTH } from '../shared/constants';

export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '&, & *': {
            boxSizing: 'border-box',
        },
    },
    isFullWidth: {},
    error: {},
    scrollWrapper: {
        position: 'relative',
        width: '100%',
    },
    contentArea: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    scrollContainer: {
        position: 'relative',
        overflow: 'auto',
        width: '100%',
        maxHeight: 70,
        minHeight: 54,
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        scrollBehavior: 'smooth',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
    },
    navArrowBase: {
        userSelect: 'none',
        zIndex: 20,
        border: 'none',
        position: 'absolute',
        display: 'none',
        alignItems: 'center',
        overflow: 'hidden',
        top: 0,
        bottom: 0,
        width: 32,
        pointerEvents: 'none',
    },
    navPrev: {
        background: `linear-gradient(to right, ${theme.colors.primary.white} 60%, transparent 100%)`,
        justifyContent: 'flex-start',
        paddingLeft: 8,
        left: 0,
    },
    navNext: {
        background: `linear-gradient(to left, ${theme.colors.primary.white} 60%, transparent 100%)`,
        justifyContent: 'flex-end',
        paddingRight: 8,
        right: 0,
    },
    navArrowShow: {
        display: 'flex !important',
    },
    navBtnDisabled: {
        opacity: 0,
        pointerEvents: 'none',
        '& $navArrowIcon': {
            pointerEvents: 'none',
        },
    },
    navArrowIcon: {
        pointerEvents: 'auto',
        cursor: 'pointer',
    },
    dropZone: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        width: '100%',
        height: '100%',
        borderRadius: 8,
        padding: 8,
        cursor: 'pointer',
        borderWidth: 1,
        borderStyle: 'dashed',
        transition: 'all 0.2s ease',
        '&:focus': {
            outline: 'none',
        },
        '& strong': {
            fontWeight: 500,
            color: theme.colors.actionMajor[500],
        },
    },
    dropZoneContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        gap: 8,
    },
    dropZoneActive: {
        borderColor: theme.colors.actionMinor[500],
        backgroundColor: theme.colors.actionMinor[100],
    },
    dropZoneInactive: {
        borderColor: theme.colors.actionMinor[200],
        backgroundColor: theme.colors.actionMinor[50],
    },
    dropZoneError: {
        borderColor: theme.colors.semantic.negative500,
        backgroundColor: theme.colors.semantic.negativeCustom100,
    },
    dropZoneDisabled: {
        borderColor: theme.colors.grey[100],
        backgroundColor: theme.colors.grey[50],
        cursor: 'not-allowed',
        '& strong': {
            color: theme.colors.grey[400],
        },
    },
    disabled: {},
    isReadOnly: {},
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        flexShrink: 0,
        pointerEvents: 'none',
    },
    title: {
        pointerEvents: 'none',
    },
    fileContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        padding: '6px 6px 6px 12px',
        borderRadius: 8,
        backgroundColor: theme.colors.actionMinor[50],
        border: `1px solid ${theme.colors.grey[100]}`,
        width: FILE_ITEM_WIDTH,
        height: 54,
    },
    fileImagePreview: {
        width: 24,
        height: 24,
        objectFit: 'cover',
        borderRadius: 4,
    },
    fileInfo: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
    },
    fileNameContainer: {
        display: 'flex',
        minWidth: 0,
    },
    fileName: {
        display: 'inline-block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    fileExtension: {
        flexShrink: 0,
    },
    fileSize: {
        marginTop: 2,
    },
    fileActions: {
        display: 'flex',
        flexFlow: 'column wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 4,
    },
    actionButton: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 20,
        height: 20,
        borderRadius: '50%',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: theme.colors.grey[200],
        },
    },
    actionButtonDisabled: {
        cursor: 'not-allowed',
        opacity: 0.5,
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    downloadButton: {},
    removeButton: {},
});
